import React from 'react';
import { fmtEUR } from '../../calculations/budgetCalculations.js';

/**
 * Section pliable de l'étape Budget. Une seule section est ouverte à la fois (accordéon
 * exclusif géré par le parent). Repliée : en-tête neutre avec résumé + prix en direct,
 * jamais en surbrillance. Ouverte : contenu complet + bouton "Continuer" optionnel qui
 * replie la section et ouvre la suivante (absent sur la dernière section).
 */
const AccordionSection = ({ title, summary, priceLow, priceHigh, isOpen, onHeaderClick, onContinue, children }) => (
  <div className={`rw-accordion-section ${isOpen ? 'rw-accordion-section--open' : ''}`}>
    <button type="button" className="rw-accordion-header" onClick={onHeaderClick}>
      <span className="rw-accordion-chevron">{isOpen ? '▾' : '▸'}</span>
      <span className="rw-accordion-title">{title}</span>
      {!isOpen && summary && <span className="rw-accordion-summary">{summary}</span>}
      <span className="rw-accordion-price">{fmtEUR(priceLow)} – {fmtEUR(priceHigh)} €</span>
    </button>

    {isOpen && (
      <div className="rw-accordion-body">
        {children}
        {onContinue && (
          <div className="rw-accordion-continue-row">
            <button type="button" className="apv2-footer-btn-cta" onClick={onContinue}>
              Continuer →
            </button>
          </div>
        )}
      </div>
    )}
  </div>
);

export default AccordionSection;
